import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import PageError from 'assets/error.svg';
import { GenericMessage } from '@ondeck/silkworm';

const ErrorPage = () => {
  const intl = useIntl();
  const homePage = '/resources/#/home';

  return (
    <GenericMessage
      image={PageError}
      title={intl.formatMessage({ id: 'errorPage.title' })}
      message={intl.formatMessage({ id: 'errorPage.content' })}
      action={
        <Button href={window.env.REACT_APP_PARTNER_PORTAL + homePage}>
          <FormattedMessage id="common.button.home" />
        </Button>
      }
    />
  );
};

export default ErrorPage;
